import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { useHomeDialogs } from "@/hooks/useHomeDialogs";
import { SERVICES } from "@/data/services";
import { scrollToId } from "@/lib/api";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ServiceSection } from "@/components/ServiceSection";
import { ServicesIntro } from "@/components/services/ServicesIntro";
import { GiuliaTeaser } from "@/components/GiuliaTeaser";
import { Gallery } from "@/components/Gallery";
import { AiStudio } from "@/components/AiStudio";
import { Bio } from "@/components/Bio";
import { ContactFooter } from "@/components/ContactFooter";
import { GarageCard } from "@/components/GarageCard";
import { Reviews } from "@/components/Reviews";
import { TipModal } from "@/components/TipModal";
import { QuoteModal } from "@/components/QuoteModal";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { Fragment } from "react";

export default function HomePage() {
  const { quote, tip, openTip, closeTip, openQuote, closeQuote } = useHomeDialogs();
  useSmoothScroll();
  return (
    <div className="relative min-h-screen bg-ink text-slate-50 antialiased">
      <div className="grain" aria-hidden="true" />
      <Nav onTip={() => openTip("nav")} />
      <main>
        <Hero onQuote={openQuote} />
        <Marquee />
        <ServicesIntro />
        {SERVICES.map((service, index) => <Fragment key={service.id}>
          <ServiceSection service={service} reverse={index % 2 === 1} onQuote={openQuote} onAi={() => scrollToId("#atelier-ia")} />
          {service.id === "ia-digital" && <GiuliaTeaser />}
        </Fragment>)}
        <Gallery onQuote={openQuote} />
        <AiStudio onQuote={openQuote} />
        <Bio />
        <GarageCard />
        <Reviews />
        <ContactFooter onTip={() => openTip("footer")} />
      </main>
      <QuoteModal open={quote.open} service={quote.service} prefillMessage={quote.prefill} onClose={closeQuote} onSent={() => openTip("apres_devis")} />
      <TipModal open={tip.open} source={tip.source} onClose={closeTip} />
      <FloatingWhatsApp />
    </div>
  );
}